/**
 * @generated SignedSource<<e66c7b3eed506d87bbfd2644fe3ebd5f>>
 * @relayHash 14483244b17ec100310300c91a84f702
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 698302250ad1dfbbfb787bec4d645d7edba86da66a6b49eecee1708827dde5f6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getCurrentUserRelayQuery$variables = {
  accountId: string;
};
export type getCurrentUserRelayQuery$data = {
  readonly user: {
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
};
export type getCurrentUserRelayQuery = {
  response: getCurrentUserRelayQuery$data;
  variables: getCurrentUserRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getCurrentUserRelayQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getCurrentUserRelayQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "698302250ad1dfbbfb787bec4d645d7edba86da66a6b49eecee1708827dde5f6",
    "metadata": {},
    "name": "getCurrentUserRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e1f043319049bb505255b5c6763fa29d";

export default node;
